var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-box"},[_c('div',{attrs:{"id":"container"}}),_c('Search',{ref:"searchRef",attrs:{"city":_vm.city},on:{"changeZoom":_vm.changeZoom}}),_c('HouseList'),_c('Tools',{ref:"toolsRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }